import { Grid, GridColumn, Icon, Separator, Spinner } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { useContext, useEffect } from 'react';
import { RootStoreContext } from '../stores/RootStore';
import { getAddressLabel } from '../util/AddressUtil';
const PersonContactAddress = observer(() => {
    const { translateStore: { translate }, personAddressStore } = useContext(RootStoreContext);
    useEffect(() => {
        personAddressStore.loadPersonAddress();
    }, []);
    const address = personAddressStore.primeContactAddress && personAddressStore.primeContactAddress.address;
    if (personAddressStore.isFetching) {
        return (React.createElement(GridColumn, { width: ['xs-12', 'md-4'], border: ['bottom-xs', 'left-md', 'bottom-none-md'] },
            React.createElement(Spinner, null)));
    }
    return (React.createElement(GridColumn, { width: ['xs-12', 'md-4'], border: ['bottom-xs', 'left-md', 'bottom-none-md'] },
        React.createElement("div", null,
            React.createElement(Grid, { gutter: "none" },
                React.createElement(GridColumn, { width: ['xs-2', 'sm-1', 'md-12'] },
                    React.createElement(Icon, { modifiers: "#home", className: "h1" }),
                    React.createElement(Separator, { color: "invisible", spacing: "xxsmall" })),
                React.createElement(GridColumn, { width: ['xs-10', 'sm-8', 'md-12'] },
                    React.createElement(Grid, null,
                        React.createElement(GridColumn, { width: ['xs-8'] },
                            React.createElement("p", { className: "text-light text-small" }, translate('personContactAddress.addressLabel')),
                            React.createElement("p", null, address ? getAddressLabel(address) : '-')),
                        address && address.room && (React.createElement(GridColumn, { width: ['xs-4'] },
                            React.createElement("p", { className: "text-light text-small" }, translate('personContactAddress.roomLabel')),
                            React.createElement("p", null, address.room || '')))))))));
});
export default PersonContactAddress;
